<template>
    <div  class="about-section  bg-gradient-to-br from-green-400 to-green-500">
      <h1 class="text-white pt-8"> {{ t('aboutHeader') }} </h1>
      <!-- <h1 class="text-white">Pourquoi Nous Choisir</h1> -->
      <div class="content">
        <div class="feature" v-for="(feature, index) in features" :key="index">
          <div class="icon-wrapper">
            <img :src="feature.icon" :alt="feature.title" />
          </div>
          <h3>{{ feature.title }}</h3>
          <p>{{ feature.description }}</p>
        </div>
      </div>
    </div>
</template>
  
<script setup>
import { useI18n } from 'vue-i18n' // Import useI18n
  
const { t } = useI18n() // Destructure t (translation function)
  

  const features = [
  {
    icon: 'https://cdn-icons-png.flaticon.com/512/12084/12084636.png',
    title: t('features.title1'), // Dynamically translated title
    description: t('description.about1') // Dynamically translated description
  },
  {
    icon: 'https://cdn-icons-png.flaticon.com/512/12084/12084636.png',
    title: t('features.title2'), // Dynamically translated title
    description: t('description.about2') // Dynamically translated description
  },
  {
    icon: 'https://cdn-icons-png.flaticon.com/512/12084/12084636.png',
    title: t('features.title3'), // Dynamically translated title
    description: t('description.about3') // Dynamically translated description
  }
]


</script>
  
<style scoped>
.about-section {
    padding: 5rem 2rem;
    background-color:#22c55e;
    text-align: center;
}
  
.about-section h1 {
    font-size: 2.5rem;
    font-weight: 800;
    margin-bottom: 3rem;
    color: white;
    position: relative;
    display: inline-block;
}
  
  .about-section h1::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 4px;
    background: #ffffff;
    border-radius: 2px;
  }
  
  .content {
    display: flex;
    justify-content: center;
    gap: 3rem;
    flex-wrap: wrap;
    max-width: 1200px;
    margin: 0 auto;
  }
  
  .feature {
    flex: 1;
    min-width: 280px;
    max-width: 350px;
    text-align: center;
    padding: 2rem;
    background: white;
    border-radius: 20px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }
  
  .feature:hover {
    transform: translateY(-10px);
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
  }
  
  .icon-wrapper {
    width: 120px;
    height: 120px;
    margin: 0 auto 1.5rem;
    background: #f0f4ff;
    border-radius: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.3s ease;
  }
  
  .feature:hover .icon-wrapper {
    transform: scale(1.1);
  }
  
  .icon-wrapper img {
    width: 60%;
    height: auto;
    transition: transform 0.3s ease;
  }
  
  .feature:hover .icon-wrapper img {
    transform: rotate(5deg);
  }
  
  .feature h3 {
    font-size: 1.5rem;
    font-weight: 700;
    margin-bottom: 1rem;
    color: #1a237e;
  }
  
  .feature p {
    font-size: 1.1rem;
    color: #555;
    line-height: 1.6;
  }
  
  /* Responsive Design */
  @media (max-width: 968px) {
    .content {
      gap: 2rem;
    }
    
    .feature {
      min-width: 260px;
    }
  }
  
  @media (max-width: 768px) {
    .about-section {
      padding: 3rem 1rem;
    }
  
    .about-section h1 {
      font-size: 2rem;
    }
  
    .feature {
      padding: 1.5rem;
    }
  
    .icon-wrapper {
      width: 100px;
      height: 100px;
    }
  }
  
  /* Optional: Add animation on scroll */
  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  .feature {
    animation: fadeInUp 0.6s ease-out forwards;
  }
  
  .feature:nth-child(2) {
    animation-delay: 0.2s;
  }
  
  .feature:nth-child(3) {
    animation-delay: 0.4s;
  }
  </style>